import {LOAD_SUCURSALES_SUCCESS, RecoleccionActionTypes} from "../types/recoleccionActionTypes";
import {Sucursal} from "../../entities/catalogos/Sucursal";

export default function sucursalReducer(state = [], action: RecoleccionActionTypes): Sucursal[]{
    switch (action.type) {
        case LOAD_SUCURSALES_SUCCESS:
            return action.sucursales;
        default:
            return state;
    }
}

